export const companyProfile = {
    addFavoriteCompny: 'Add to Favourite Company List',
    removeFavoriteCompny: 'Remove from Favourite Company List',

    fileDownloadError: 'Download failed. Please contact the support team.',

    companyTableColumnTheme: 'Theme',
    companyTableColumnCompany: 'Company',
    companyTableColumnRanking: 'Ranking',
    companyTableColumnAffinity: 'Affinity with \n Company',
    companyTableColumnAmount: 'Minority Investment \n Amount [m JPY]',

    ipcName: 'Technology Classification',
    patentcount: 'Number of Patent Application',

    companyBodyDescription: `Displaying IP (intellectual property) information for the selected company.\nYou can add companies to favorites if it is considered as a candidate for alliance or invesment based on its financial conditions and technologcal capabilities.`,

    companyRadioTable: 'Themes with high affinity to the company',
    companyRadioTableLink: 'View details',
    companyRadioTableDescription:
        'You can check the themes with a high percentage of patents that the company holds for each respective theme',
    companyTips:
        'When you select a theme, it will be reflected in Time Series of Patent Applications chart on the left.',
    companyRadioTablecoulmn1: 'Rank',
    companyRadioTablecoulmn2: 'Theme Name',

    companyBodyFinanceTitle: 'Company Profile'
}
